import './Stack.css';

import * as React from 'react';

export class Stack extends React.Component {
  render() {
    return <div className="stack">{this.props.children}</div>;
  }
}
